var map = {
	"./shifu1.png": 6053,
	"./shifu2.png": 302,
	"./shifu3.png": 7991,
	"./shifu4.png": 6472,
	"./shifu5.png": 6417,
	"./shifu6.png": 8106,
	"./shifu7.png": 9683,
	"./shifu8.png": 9460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8267;